var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "Chart_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Chart_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2563EB",
  d: "M3 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 2 20q0-.424.288-.712A.97.97 0 0 1 3 19h18q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 21 21zm1.5-3q-.625 0-1.062-.437A1.45 1.45 0 0 1 3 16.5v-4q0-.625.438-1.062A1.45 1.45 0 0 1 4.5 11q.624 0 1.063.438Q6 11.875 6 12.5v4q0 .625-.437 1.063A1.45 1.45 0 0 1 4.5 18m5 0q-.625 0-1.062-.437A1.45 1.45 0 0 1 8 16.5v-9q0-.625.438-1.062A1.45 1.45 0 0 1 9.5 6q.624 0 1.063.438Q11 6.874 11 7.5v9q0 .625-.437 1.063A1.45 1.45 0 0 1 9.5 18m5 0q-.625 0-1.062-.437A1.45 1.45 0 0 1 13 16.5v-6q0-.625.438-1.062A1.45 1.45 0 0 1 14.5 9q.624 0 1.063.438Q16 9.874 16 10.5v6q0 .625-.437 1.063A1.45 1.45 0 0 1 14.5 18m5 0q-.625 0-1.062-.437A1.45 1.45 0 0 1 18 16.5v-12q0-.625.438-1.062A1.45 1.45 0 0 1 19.5 3q.625 0 1.063.438Q21 3.874 21 4.5v12q0 .625-.437 1.063A1.45 1.45 0 0 1 19.5 18"
}))));
export default SvgChart;